"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var date_fns_1 = require("date-fns");
var polished_1 = require("polished");
var React = tslib_1.__importStar(require("react"));
var config_1 = tslib_1.__importDefault(require("../../../../utilities/config"));
var styled_components_1 = tslib_1.__importDefault(require("../../../../theme/styled-components"));
var index_1 = require("../index");
var FADED_COLOR = '#7f7f7f';
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  text-align: center;\n  font-size: ", ";\n"], ["\n  text-align: center;\n  font-size: ", ";\n"])), polished_1.rem(14));
var CompetitionName = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  font-weight: bold;\n  > span {\n    font-weight: normal;\n    color: ", ";\n  }\n"], ["\n  font-weight: bold;\n  > span {\n    font-weight: normal;\n    color: ", ";\n  }\n"])), FADED_COLOR);
var EventDateTime = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), FADED_COLOR);
var EventName = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject([""], [""])));
var ScoreBoard = styled_components_1["default"].div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: space-around;\n  padding: ", ";\n  align-items: center;\n  > div {\n    width: calc(100% / 3);\n  }\n"], ["\n  display: flex;\n  justify-content: space-around;\n  padding: ", ";\n  align-items: center;\n  > div {\n    width: calc(100% / 3);\n  }\n"])), polished_1.rem(16));
var ScoreBoardInfo = styled_components_1["default"].div(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var Team = styled_components_1["default"].div(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject([""], [""])));
var Flag = styled_components_1["default"].div(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject([""], [""])));
var TeamName = styled_components_1["default"].div(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject([""], [""])));
var Score = styled_components_1["default"].div(templateObject_10 || (templateObject_10 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n"], ["\n  font-size: ", ";\n"])), polished_1.rem(28));
var ScoreBoardStatus = styled_components_1["default"].div(templateObject_11 || (templateObject_11 = tslib_1.__makeTemplateObject([""], [""])));
var Stats = styled_components_1["default"].div(templateObject_12 || (templateObject_12 = tslib_1.__makeTemplateObject(["\n  div {\n    padding: ", " 0;\n    text-align: left;\n  }\n"], ["\n  div {\n    padding: ", " 0;\n    text-align: left;\n  }\n"])), polished_1.rem(8));
var C = function (_a) {
    var competitionName = _a.competitionName, eventName = _a.eventName, eventDateTime = _a.eventDateTime, eventSpecification = _a.eventSpecification, season = _a.season, score = _a.score, setScores = _a.setScores, stats = _a.stats, matchStatus = _a.matchStatus, opponent1Id = _a.opponent1Id, opponent1Name = _a.opponent1Name, opponent2Id = _a.opponent2Id, opponent2Name = _a.opponent2Name;
    var translateMatchStatus = function () {
        switch (matchStatus) {
            case 'finished':
                return 'Ukončený';
            case 'retired':
                return 'Kontumovaný';
            case 'live':
                return 'Prebiehajúci';
            case 'canceled':
                return 'Zrušený';
            case 'postponed':
                return 'Odložený';
            case 'scheduled':
                return 'Plánovaný';
            case 'intermission':
                return 'Prestávka';
            default:
                return matchStatus;
        }
    };
    return (React.createElement(Wrapper, null,
        React.createElement(CompetitionName, null,
            competitionName,
            (eventSpecification || season) && (React.createElement(React.Fragment, null,
                "\u00A0",
                React.createElement("span", null,
                    eventSpecification,
                    " ",
                    season)))),
        eventDateTime && (React.createElement(EventDateTime, null,
            date_fns_1.format(eventDateTime, config_1["default"].DEFAULT_DATE_FORMAT),
            " o",
            ' ',
            date_fns_1.format(eventDateTime, config_1["default"].DEFAULT_TIME_FORMAT))),
        eventName && React.createElement(EventName, null, eventName),
        React.createElement(ScoreBoard, null,
            React.createElement(Team, null,
                React.createElement(Flag, null,
                    React.createElement("img", { src: "https://onlajny.s3.amazonaws.com/team/logo/" + opponent1Id })),
                React.createElement(TeamName, null, opponent1Name)),
            React.createElement(ScoreBoardInfo, null,
                React.createElement(Score, null, score),
                React.createElement("div", null,
                    "(",
                    (setScores || []).map(function (i) { return i; }).join(', '),
                    ")"),
                React.createElement(ScoreBoardStatus, null, translateMatchStatus())),
            React.createElement(Team, null,
                React.createElement(Flag, null,
                    React.createElement("img", { src: "https://onlajny.s3.amazonaws.com/team/logo/" + opponent2Id })),
                React.createElement(TeamName, null, opponent2Name))),
        stats && (React.createElement(Stats, null,
            React.createElement(index_1.Header, null, "Preh\u013Ead"),
            React.createElement("div", { dangerouslySetInnerHTML: { __html: stats } })))));
};
exports["default"] = React.memo(C);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;
